//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    styles: { type: String, required: true },
    isActive: { type: Boolean, required: true },
    image: { type: String, default: '' },
    recycled: { type: Boolean, default: false }
  },
  computed: {
    classes () {
      return {
        BaseChoice: true,
        'BaseChoice--active': this.isActive
      }
    }
  },
  methods: {
    resolveImage (src) {
      return require(`~/assets/images${src.startsWith('/') ? '' : '/'}${src}`)
    }
  }
}
